import React from "react";
import classNames from "classnames";

const SpinnerBorder = ({ isCenter, size = "sm", style, className }) => {
  return (
    <div
      className={classNames(
        `spinner-border spinner-border-${size}`,
        isCenter && "d-flex justify-content-center mx-auto mt-0",
        className
      )}
      style={style}
      role="status"
    ></div>
  );
};

export default SpinnerBorder;
